<template>
  <div class="panel-box">
    <!-- <h3 @click="isCollapse">融像{{isSetting?'设置':'数据'}}
      <u-icon :name="showVergenceSetting ? 'ChevronDownMed' : 'ChevronRightMed'" />
    </h3> -->
    <div :class="isSetting?'panel-setting':''"
         v-show="showVergenceSetting">
      <h3>水平融像</h3>
      <h4>手/自动： {{this.$store.state.therapy.vergence.mode}}
        <span v-if="isSetting"
              class="radio">
          <input class="option-radio"
                 type="radio"
                 id="auto"
                 value="Auto"
                 v-model="mode">
          <label for="auto">自动</label>

          <input class="option-radio"
                 type="radio"
                 id="manual"
                 value="Manual"
                 v-model="mode">
          <label for="manual">手动</label>
        </span>
      </h4>
      <h4 v-if="!isSetting">融像需求：{{horizontal.vergenceDemand.toFixed(2)}}</h4>
      <!-- 融像范围 -->
      <div v-show="hasConfig('horizontal-range')">
        <h4>融像范围：{{range}}</h4>
        <!-- <h4>融像范围：[{{range[0]}}~{{range[1]}}] -->
          <v-slider v-if="isSetting"
                    :value="range"
                    :max="40"
                    :min="-20"
                    tooltip="hover"
                    lazy
                    @input="updateRange" />
        </h4>
      </div>
      <div>
        <!-- 融像模式 -->
        <div v-show="hasConfig('horizontal-moveMode')">
          <h4>融像模式: {{horizontal.moveMode}}</h4>
          <div v-if="isSetting"
               class="radio">
            <input type="radio"
                   v-model="horizontal.moveMode"
                   value="smooth"
                   checked
                   class="option-radio"
                   id="moveMode1">
            <label for="moveMode1">平滑</label>
            <input type="radio"
                   v-model="horizontal.moveMode"
                   value="jump"
                   class="option-radio"
                   id="moveMode2">
            <label for="moveMode2">跳跃</label>
          </div>
        </div>
      </div>
      <!-- 融像速度 -->
      <div v-show="hasConfig('horizontal-speed')">
        <h4>融像速度：{{horizontal.speed}}
          <vue-numeric-input v-if="isSetting"
                             v-model.number="horizontal.speed"
                             :min="1"
                             :max="10"
                             :step="1" />
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
// import * as Vergence from '@therapy/constants/vergenceConfig'
import { mapState } from 'vuex'

export default {
  props: {
    isSetting: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    let horizontal = this.$store.state.therapy.vergence.horizontal
    return {
      mode: this.$store.state.therapy.vergence.mode,
      horizontal,
      showVergenceSetting: true,
      vdRangeOption: {
        value: horizontal.range,
        min: -20,
        max: 40,
      },
      // Vergence,
    }
  },
  computed: {
    ...mapState({
      range: state => state.therapy.vergence.horizontal.range,
    }),
    // range: {
    //   get() {
    //     return this.$store.state.therapy.vergence.horizontal.range
    //   },
    // set(val) {
    //   this.$store.commit('therapy/vergence/setRange', val)
    //   // this.horizontal.range = val
    // },
    //   },
  },

  methods: {
    updateRange(val) {
      this.$store.commit('therapy/vergence/setRange', val)
    },
    hasConfig(configName) {
      let g = this.$store.state.therapy.globalConfig
      return g.Vergence && g.Vergence.includes(configName)
    },
    isCollapse() {
      // this.showVergenceSetting = !this.showVergenceSetting
    },
  },
}
</script>
